import styles from './Menu.module.css';
import { useAuth } from '../../contextos/AuthContext'; // Importa o hook useAuth do contexto de autenticação para acessar o estado do usuário logado e funções relacionadas à autenticação
import fotoIndisponivel from "../../assets/imagens/indisponivel.png";
import {  LogIn } from 'lucide-react';

// Componente Menu que recebe a prop aoClicarLogin para abrir o modal de login
export default function Menu ({ aoClicarLogin, aoLogout}) {  
    const usuario = useAuth().dadosUsuario; // Hook para acessar o contexto de autenticação e obter os dados do usuário logado
    
    
    return (

        
        <div className={styles.header}>            
            <nav className={styles.navBar}>
                { usuario && (
                    <div className={styles.usuarioBox}>
                        <div className={styles.usuarioInfo}>
                            <img 
                            src={usuario.foto ? usuario.foto : fotoIndisponivel} 
                                alt="Foto do usuário" 
                                className={styles.avatar} 
                                
                            />
                            {/* Exibe o primeiro nome do usuário logado */}
                            
                            <span className={styles.usuario } >{usuario.nome.split(' ')[0]}</span>
                        </div>
                    
                        {/* Botão de sair */}
                        <button className={styles.botao} onClick={aoLogout}> 
                            <strong>Sair</strong>
                        </button>
                        
                    </div>
                    )
                }


                {/*Este item em específico possui uma prop onClick que chama a função passada como prop para abrir o modal de login 
                */}
        
                {!usuario && (
                    // Se o usuário não estiver logado, mostramos os itens de cadastro e login
                    <div className="d-flex flex-column align-items-center">
                   
                    <button className={styles.botaoEntrar} onClick={aoClicarLogin}> 
                        <LogIn size={20} />
                        <span>Entrar</span>
                    </button>
                    </div>
                    )
                }       
            </nav>
        </div>
    )
}

